import PropTypes from "prop-types";
import React from "react";
import ReportDefinitions from "../../../../common/config/ReportDefinitions";
import Report from "../../../common/components/Report";
import noop from "../../../../../core/modules/common/tools/noop";

// eslint-disable-next-line react/prefer-stateless-function
class CarditCriticalElementsReport extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Report
        id={this.props.id}
        tabs={[
          {
            value: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
            label: "Carrier",
          },
          {
            value: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
            label: "Location",
            loadFromTable: true,
            loadFromTableMessage: "app.warning.load.from.summary.report",
          },
          {
            value: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.id,
            label: "Details",
            loadFromTable: true,
            loadFromTableMessage: "app.warning.load.from.summary.report",
          },
        ]}
        {...this.props}
      />
    );
  }
}

export default CarditCriticalElementsReport;

CarditCriticalElementsReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  prepareData: PropTypes.func,
};
CarditCriticalElementsReport.defaultProps = {
  id: "",
  data: [],
  columns: [],
  generatedOnDateTime: "",
  isLoading: false,
  reportId: "",
  onSortedChange: noop,
  onFilteredChange: noop,
  prepareData: (d) => d,
};
